import { projects } from '../data/portfolio';
import { ProjectArt } from './projectArt';
import { Arrow, SectionLabel } from './ui';
import mango from '../images/mango.jpg';

function ProjectCard({ project, total }) {
  const illustrated = ['consolidation', 'collectors'].includes(project.id);
  return (
    <article className={`project-card project-${project.id}`} aria-labelledby={`${project.id}-title`}>
      {illustrated && <ProjectArt type={project.id} />}
      <div className="project-card-body">
        <div className="project-meta"><span>{project.category}</span><span>{project.number} / {String(total).padStart(2, '0')}</span></div>
        <h3 id={`${project.id}-title`}>{project.title}</h3>
        <p className="project-description">{project.description}</p>
        <ul className="tags" aria-label="Project focus">{project.tags.map(tag => <li key={tag}>{tag}</li>)}</ul>
        <details className="project-details">
          <summary>Project details <span className="sr-only">— {project.name}</span><span className="details-icon" aria-hidden="true">+</span></summary>
          <div className="project-story">
            <h4>{project.name}</h4>
            <p>{project.overview}</p>
            <h5>My responsibilities</h5>
            <p>{project.contribution}</p>
            <ul>{project.scope.map(item => <li key={item}>{item}</li>)}</ul>
            {project.note && <p className="project-note">{project.note}</p>}
            {project.url && <a className="text-link" href={project.url} target="_blank" rel="noreferrer">{project.linkText} <Arrow /><span className="sr-only"> (opens in a new tab)</span></a>}
          </div>
        </details>
      </div>
    </article>
  );
}

export function Portfolio() {
  return (
    <section className="work-section section-space" id="work" aria-labelledby="work-heading">
      <div className="container">
        <SectionLabel number="01">Projects</SectionLabel>
        <div className="section-heading-row">
          <h2 id="work-heading">Selected Work</h2>
          <div className="work-heading-note"><p>These projects cover different aspects of my work at Stickley, from website consolidation to ongoing development and integrations.</p></div>
        </div>
        <div className="work-context"><span className="availability-dot" /> STICKLEY <span>In-house front-end developer</span><span>September 2022 — Present</span></div>
        <div className="projects-grid">{projects.map(project => <ProjectCard key={project.id} project={project} total={projects.length} />)}</div>
        <details className="earlier-work">
          <summary><span><span className="eyebrow">Earlier work</span> Mango Farm Assets</span><span className="details-icon" aria-hidden="true">+</span></summary>
          <div className="earlier-work-body"><div><h3>Mango Farm Assets</h3><p>I co-designed the interface and implemented the Figma designs in HTML and CSS.</p></div><img src={mango} alt="Archived screenshot of the Mango Farm Assets interface" width="2998" height="1690" loading="lazy" decoding="async" /></div>
        </details>
      </div>
    </section>
  );
}
